<template>
  <div
    class="block-compendium"
  >
    <BlockAccordion :data="accordionElement" />
  </div>
</template>

<script setup>
defineProps({
    data: {
        type: Object,
        default: () => {},
    },
});

const accordionElement = ref({});

/*
    This is a workaround to get the HTML from the hci data and pass it to the AtomRichtext component
*/
provide('useHTML', true);

onMounted(() => {
    const storyStore = useStoryStore();
    const strapiData = 'compendium';

    // Get the raw data from the strapi data
    const rawData = storyStore.getConnectedStrapiValue(strapiData);

    if (!rawData) {
        return;
    }

    // Create a wrapper element to parse the HTML
    const wrapper = document.createElement('div');
    wrapper.innerHTML = rawData;

    const paragraphs = wrapper.querySelectorAll('.paragraph');
    const title = wrapper.querySelector('p');
    const filteredParagraphs = [];

    // Filter out paragraphs that don't have a h2 and p tag
    paragraphs.forEach((paragraph) => {
        const h2 = paragraph.querySelector('h2');
        const p = paragraph.querySelectorAll('p');

        // If there is a h2 and p tag, add it to the filteredParagraphs array
        if (h2 && p.length !== 0) {
            // Get the HTML from the p tag
            const htmlstr = Array.prototype.reduce.call(p, (html, node) => html + (node.outerHTML || node.nodeValue), '');

            // Add the h2 and p tag to the filteredParagraphs array
            filteredParagraphs.push({
                title: h2.innerText,
                textCompendium: htmlstr,
            });
        }
    });

    // prepare accordion element object
    accordionElement.value.accordion_element = filteredParagraphs;
    accordionElement.value.theme = 'secondary';
    accordionElement.value.title = title.innerText;
});

</script>

<style lang="scss">
.block-compendium {
    @include grid-columns();
    @include component-spacing(30px, 120px);

    .atom-richtext {
        p {
            @include fluid('margin-bottom', 10px, 20px);
        }
    }
}
</style>
